// extracted by mini-css-extract-plugin
module.exports = {"iconFacebook":"FacebookShareButton_iconFacebook__GD_Rs"};